import ChevronLeft from '@material-ui/icons/ChevronLeft'
import React from 'react'
import { Button } from 'webbook-airways'

export const BackButton = ({ color, children }) => (
  <Button variant="text" style={{ color }}>
    <ChevronLeft style={{ fontSize: 18, marginRight: 8 }} />
    {children}
  </Button>
)
